module.exports = __webpack_public_path__ + "img/onigiri.2c57d289.png";